import { useEffect, useRef, useState } from "react";
import { CalendarCheck } from "lucide-react";
import { calendlyUrl } from "@/lib/calendlyUrl";

const SRC = "https://assets.calendly.com/assets/external/widget.js";
const loadScript = () => new Promise((res) => {
  if (window.Calendly) { res(); return; }
  let s = document.querySelector(`script[src="${SRC}"]`);
  if (!s) { s = document.createElement("script"); s.src = SRC; s.async = true; document.body.appendChild(s); }
  s.addEventListener("load", () => res());
});

export default function CalendlyEmbed({ b, value, onChange, prefill, preview }) {
  const ref = useRef(null);
  const [err, setErr] = useState(false);
  const url = calendlyUrl(b.calendly_url, b.calendly_hide_details, prefill);
  useEffect(() => {
    if (preview || !url || value) return undefined;
    let alive = true;
    loadScript().then(() => {
      if (!alive || !ref.current) return;
      ref.current.innerHTML = "";
      try { window.Calendly.initInlineWidget({ url, parentElement: ref.current }); } catch { setErr(true); }
    });
    const onMsg = (e) => {
      if (e.origin !== "https://calendly.com" || e.data?.event !== "calendly.event_scheduled") return;
      const p = e.data.payload || {};
      onChange({ event_uri: p.event?.uri, invitee_uri: p.invitee?.uri, booked_at: new Date().toISOString() });
    };
    window.addEventListener("message", onMsg);
    return () => { alive = false; window.removeEventListener("message", onMsg); };
  }, [url, preview, value]); // eslint-disable-line react-hooks/exhaustive-deps
  if (preview) return <div className="text-sm opacity-60" data-testid={`calendly-preview-${b.id}`}>Your Calendly page embeds here on the published form{url ? "" : " (add the Calendly link in the block settings)"}.</div>;
  if (!url) return <div className="text-sm opacity-60">Booking isn't set up yet.</div>;
  if (value) return <div className="flex items-center gap-2 text-lg" data-testid={`calendly-booked-${b.id}`}><CalendarCheck size={20} />You're booked. Submitting…</div>;
  return (
    <div data-testid={`calendly-embed-${b.id}`}>
      <div ref={ref} className="w-full rounded-lg overflow-hidden" style={{ height: typeof window !== "undefined" && window.innerWidth < 640 ? (b.calendly_hide_details ? 780 : 1050) : 700 }} />
      {err && <a href={url} target="_blank" rel="noreferrer" className="underline text-sm">Open the booking page</a>}
    </div>
  );
}
